const emoObject = {
  Ужас: {
    function: "защитить нас от смертельной опасности, сильнейшего потрясения",
    trigger: `столкновение с угрозой смерти, вреда здоровью, с серьезной потерей`,
    thoughts: `«Что мне делать...»,
        «Мне конец, «Я в большой опасности»`,
    symptoms: `учащённое сердцебиение,
        расстройство желудка, тошнота, ком в горле,
        одышка, дрожь, оцепенение, онемение конечностей, потливость.`,
  },
  Страх: {
    function: "защитить нас от опасности",
    trigger: `столкновение с угрозой, публичное выступление,
        столкновение с новой ситуацией`,
    thoughts: `«Я не справлюсь с этим»,
        «Я провалюсь, «Я в опасности»`,
    symptoms: `учащённое сердцебиение,
        расстройство желудка, тошнота, ком в горле,
        одышка, дрожь.`,
  },
  Тревога: {
    function: "защитить нас от будущей опасности",
    trigger: `мысли о будущей
        опасной ситуации.`,
    thoughts: `«Я не справлюсь с этим», «Он бросит меня»,
        «Что, если...»`,
    symptoms: `трудности с расслаблением,
        напряжение мышц, бессонница, трудности
        с концентрацией внимания, учащённое
        сердцебиение, тошнота, нервозность.`,
  },
  Трепет: {
    function: "обратить наше внимание, что происходит нечто важное",
    trigger: `нечто огромное, что бросает вызов нашим привычным рамкам восприятия в той или иной области`,
    thoughts: `«Это волнует меня», «Скорей бы это случилось...»`,
    symptoms: `прилив энергии, учащённое
        сердцебиение, учащенное сердцебиение.`,
  },
  Злость: {
    function: `защита при физическом или моральном
        нападении; борьба за то, что важно; преодоление
        препятствий.`,
    trigger: `ощущение
        угрозы, невозможность получить желаемое,
        физическая или эмоциональная боль.`,
    thoughts: `«Я этого не заслуживаю»,
        «Я этого не потерплю», «Это нечестно».`,
    symptoms: `напряжение тела и лица,
        покраснение лица, сжатие кулаков и челюстей.`,
  },
  Гнев: {
    function: `более яркая эмоция, чем злость, защита при физическом или моральном
        нападении; борьба за то, что важно; преодоление
        препятствий.`,
    trigger: `ощущение
        угрозы, невозможность получить желаемое,
        физическая или эмоциональная боль, ощущение несправедливости.`,
    thoughts: `«Я этого не заслуживаю»,
        «Я этого не потерплю», «Это нечестно».`,
    symptoms: `напряжение тела и лица,
        покраснение лица, сжатие кулаков и челюстей.`,
  },
  Грусть: {
    function: `замедлить нас, позволяя справиться
        с потерей человека или желаемой цели.`,
    trigger: `потеря или отказ,
        чувство бессилия.`,
    thoughts: `«Это большая потеря»,
        «Нет никакой надежды».`,
    symptoms: `потеря энергии, слёзы, тяжесть
        в желудке, трудности с концентрацией внимания.`,
  },
  Неудовольствие: {
    function: `показать свои границы, свои ожидания и желания`,
    trigger: `потеря или отказ, неудача, нарушение границ`,
    thoughts: `«Мне не нравится»,
        «Я не хочу, чтобы было так».`,
    symptoms: `потеря энергии, напряжение тела`,
  },
  Презрение: {
    function: `показать свои границы, указать на вещи/качества, которые не являются для нас приемлемыми`,
    trigger: `неудача, нарушение границ, конфликт`,
    thoughts: `«Я бы так не поступила»,
        «Для меня это просто недопустимо».`,
    symptoms: `потеря энергии, напряжение тела, тошнота`,
  },
  Скука: {
    function: `дать передышку, пространство для действия и мысли`,
    trigger: `отсутствие задач, интереса`,
    thoughts: `«Ничего не хочется делать»,
        «Не знаю, чем заняться».`,
    symptoms: `потеря энергии, тяжесть`,
  },
  Горе: {
    function: `дать отгоревать потерю, восстановиться`,
    trigger: `потеря, смерть, расставание`,
    thoughts: `«Я не знаю, как пережить это»,
        «Мне больно».`,
    symptoms: `потеря энергии, тяжесть в животе, груди, слезы, дрожь, онемение конечностей, боль в голове, дереализация`,
  },
  Печаль: {
    function: `дать восстановиться`,
    trigger: `потеря, неудача, разлука`,
    thoughts: `«Мне жаль, что это случилось»,
        «Мне не хочется веселиться».`,
    symptoms: `потеря энергии, тяжесть в животе, груди, слезы, боль в голове`,
  },
  Изумление: {
    function: `дать восстановиться`,
    trigger: `потеря, неудача, разлука`,
    thoughts: `«Мне жаль, что это случилось»,
        «Мне не хочется веселиться».`,
    symptoms: `потеря энергии, тяжесть в животе, груди, слезы, боль в голове`,
  },
  Удивление: {
    function: `обратить внимание, сконцентрироваться, пересобраться`,
    trigger: `новые знакомства, неожиданные новости и события`,
    thoughts: `«Неожиданно...»,
        «Как так вышло?».`,
    symptoms: `учащение ЧСС, возбуждение`,
  },
  Возбуждение: {
    function: `дать импульс для действий`,
    trigger: `возможности, дэдлайны, внезапные встречи и события`,
    thoughts: `«Я хочу это сделать»,
        «Мне это нужно».`,
    symptoms: `прилив энергии, возбуждение, учащение ЧСС`,
  },
  Разочарование: {
    function: `обратить внимание на свои границы и пересобраться`,
    trigger: `потеря, неудача, разлука, предательство`,
    thoughts: `«Я больше не могу доверять...»,
        «Я не думала, что это могло произойти...».`,
    symptoms: `потеря энергии, тяжесть в животе, груди, слезы, боль в голове, апатия`,
  },
  Радость: {
    function: `побуждает нас приумножать то,
        что мы ценим.`,
    trigger: `ощущение
        успеха, получение любви или похвалы.`,
    thoughts: `«Это прекрасно», «Мне так повезло».`,
    symptoms: `улыбка, расслабленное тело,
        прилив энергии.`,
  },
  Безмятежность: {
    function: `побуждает нас насладиться счастливыми моментами жизни.`,
    trigger: `ощущение
        успеха, получение любви или похвалы.`,
    thoughts: `«Я счастлива», «Лучше быть не может».`,
    symptoms: `улыбка, расслабленное тело,
        прилив энергии.`,
  },
  Оптимизм: {
    function: `продолжать деятельность, не терять мотивацию`,
    trigger: `удачи, достижения`,
    thoughts: `«Стакан наполовину полон», «Мы живем в самом лучшем из миров».`,
    symptoms: `улыбка, расслабленное тело,
        прилив энергии.`,
  },
  Восторг: {
    function: `идентификация чето-то великого, масштабного и очень важного`,
    trigger: `удачи, достижения, любовь, победы`,
    thoughts: `«Вот это да!», «Невероятно».`,
    symptoms: `улыбка, расслабленное тело,
        прилив энергии, возбуждение, учащение ЧСС, дрожь.`,
  },
  Настороженность: {
    function: `быть готовым к потенциально опасности или неприятности`,
    trigger: `сомнительные ситуации, темные переулки, опасные люди`,
    thoughts: `«Что-то тут не так...», «Мне это не нравится».`,
    symptoms: `напряжение тела и лица,
        покраснение лица, сжатие кулаков и челюстей,учащение ЧСС, дрожь.`,
  },
  Ожидание: {
    function: `обратить внимание на то, что важно для нас`,
    trigger: `результаты проектов, планирование разговоров или событий`,
    thoughts: `«Интересно, как получится...»`,
    symptoms: `улыбка, расслабленное тело,
        прилив энергии, возбуждение, учащение ЧСС, дрожь.`,
  },
  Агрессия: {
    function: `ооборона, защита в моменте`,
    trigger: `нападение, конфликт`,
    thoughts: `«Я этого не позволю!», «Я сейчас взорвусь!»`,
    symptoms: `напряжение мышц, покраснение лица, прилив энергии, возбуждение, учащение ЧСС, дрожь.`,
  },
  Стыд: {
    function: `побуждать нас исправить
        поведение, нарушающее социальные нормы.`,
    trigger: `нарушение общественных правил.`,
    thoughts: `«Надеюсь, никто не узнает»,
        «Что они обо мне подумают?»`,
    symptoms: `покраснение лица,
        учащённое сердцебиение.`,
  },
  Раскаяние: {
    function: `позволить нам жить в соответствии
        с личными ценностями`,
    trigger: `сделать то, что вы считаете неправильным.`,
    thoughts: `«Я сделала что-то плохое»,
        «Я допустила ошибку».`,
    symptoms: `тошнота, трудности
        с расслаблением, напряжение мышц.`,
  },
  Отвращение: {
    function: `побудить нас отойти от чего-то,
        что может загрязнить, и не контактировать
        с тем, что нарушает наши ценности.`,
    trigger: `столкновение
        с чем-то вредным/грязным/противным/аморальным.`,
    thoughts: `«От этого меня тошнит», «Мне нужно уйти».`,
    symptoms: `тошнота, беспокойство.`,
  },
  Интерес: {
    function: `подготовить к потенциальному
        достижению или приобретению чего-то нужного.`,
    trigger: `участие в опыте,
        который привлекает наше внимание.`,
    thoughts: `«Это может быть здорово»,
        «Как я могу принять участие?»`,
    symptoms: `расширение зрачка,
        увеличение ЧСС и учащение дыхания.`,
  },
  Любовь: {
    function: `воспроизводство и выживание.`,
    trigger: `человек даёт то,
        что нам надо, восхищение другим человеком.`,
    thoughts: `«Мне нравится быть рядом»,
        «Какой красивый/интересный человек».`,
    symptoms: `расширение зрачка,
        увеличение ЧСС и учащение дыхания.`,
  },
  Доверие: {
    function: `психологическая безопасность, готовность играть по общим правилам, вести дела с другими людьми, вести совместную жизнь`,
    trigger: `романтические, дружеские, а также успешные деловые отношения`,
    thoughts: `«Мне безопасно быть рядом с этим человек»,
        «Я могу и хочу поделиться тем, что у меня в голове, с этими людьми».`,
    symptoms: `расслабление, прилив энергии`,
  },
  Принятие: {
    function: `выстроить безопасные и комфортные отношения между людьми`,
    trigger: `романтические, дружеские, семейные близкие отношения`,
    thoughts: `«Я могу быть собой»,
        «Я знаю, что найду подержку и заботу».`,
    symptoms: `расслабление, прилив энергии`,
  },
  Восхищение: {
    function: `облегчает социальное обучение в группах и мотивирует к самосовершенствованию через обучение по ролевой модели`,
    trigger: `демонстрирация таланта или умения, превосходящая общепринятые стандарты`,
    thoughts: `«Это удивительно»,
        «Я хочу добиться того же».`,
    symptoms: `прилив энергии, учащение ЧСС, возбуждение`,
  },
  Покорность: {
    function: `обезопасить нас от социальных конфликтов`,
    trigger: `столкновение с влиятельными людьми, с ситуациями, в которых мы бессильны`,
    thoughts: `«Я ничего не могу сделать»,
        «Значит так тому и быть, это судьба».`,
    symptoms: `потеря энергии, напряжение мышц`,
  },
  Досада: {
    function: `обратить внимание на свои границы и пересобраться, показать свои границы`,
    trigger: `потеря, неудача, разлука`,
    thoughts: `«Мне это не нравится», «Хочу это прекратить»,
        «Какой красивый/интересный человек».`,
    symptoms: `потеря энергии, напряжение мышц`,
  },
};

export const breathObj = [
  {
    name: "Квадрат",
    description:
      "Вдохните на 4 счета, потом сделайте паузу на 4 счета. Выдыхайте, считая до 4. Всё время дышите через нос.",
    breathIn: 4,
    breathOut: 4,
    pause: 4,
  },

  {
    name: "Лестница",
    description:
      "Закройте рот, сделайте вдох носом, считая до 4. Задержите дыхание до 7. Затем шумно выдохните, считая до 8.",
    breathIn: 4,
    breathOut: 8,
    pause: 7,
  },
  {
    name: "Удвоенная",
    description:
      "Вдохните через нос и сосчитайте до 4, затем выдыхайте в 2 раза дольше: до 8.",
    breathIn: 4,
    breathOut: 8,
    pause: 1,
  },
  {
    name: "Шмель",
    description:
      'Сделайте глубокий вдох и затем выдохните, с сомкнутыми губами создавая звук "М" - почувствуйте вибрацию в горле.',
    breathIn: 4,
    breathOut: 4,
    pause: 1,
  },
];

export default emoObject;
